import { css } from '@emotion/css';

export const marginRight72Until830px = [
  css`
    margin-right: clamp(10px, 72px - ((900px - 100vw) * 0.5), 72px);
    /* background-color: orange !important; */
  `,
  // borders.DEBUG_greenBorderDashed,
].join(' ');
